export const host = 'https://www.instabuild.com'

export const staticUrl = 'https://cloud.visualizenbuild.com/static/vnb'

export const baseUrl = 'https://www.backend.visualizenbuild.com/api'

// export const baseUrl = 'http://127.0.0.1:1080/api'